var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('Navbar'),_c('div',{staticClass:"content-wrapper"},[(_vm.isLoading)?_c('Loader'):_vm._e(),_c('div',{staticClass:"content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.content)}}),(!_vm.content.content && !_vm.isLoading)?_c('span',[_vm._v("Nothing here. :(")]):_vm._e()])],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }